module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/charlotte-giminez-a8c58bce6d83b2c799fbb4271cb33fe1.jpg";